const TONES = {
  COMPLETED: {
    label: 'Completed',
    className: 'border-emerald-500/25 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
  },
  DELIVERED: {
    label: 'Delivered',
    className: 'border-sky-500/25 bg-sky-500/10 text-sky-700 dark:text-sky-300',
  },
  PENDING: {
    label: 'Pending',
    className: 'border-amber-500/30 bg-amber-500/15 text-amber-700 dark:text-amber-300',
  },
  REFUNDED: {
    label: 'Refunded',
    className: 'border-rose-500/25 bg-rose-500/10 text-rose-700 dark:text-rose-300',
  },
  CANCELLED: {
    label: 'Cancelled',
    className: 'border-line-2 bg-ink-3/15 text-ink-2',
  },
};

/** Compact order-status pill. Unknown statuses fall back to neutral. */
export default function StatusBadge({ status, className = '' }) {
  const tone = TONES[status] ?? { label: status ?? 'Unknown', className: TONES.CANCELLED.className };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-[3px] text-[10.5px] leading-none font-semibold ${tone.className} ${className}`}
    >
      {tone.label}
    </span>
  );
}
